import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ValidationInterceptor implements HttpInterceptor {
  constructor() {}

  private isExcludedUrl(url: string, excludedUrls: string[]): boolean {
    return excludedUrls.some(excludedUrl => url.includes(excludedUrl));
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedUrls = ['maps.googleapis.com', 's3.eu-west-1.amazonaws.com'];

    if (this.isExcludedUrl(req.url, excludedUrls)) {
      return next.handle(req);
    }

    req = req.clone({
      setHeaders: {
        validation: `onelogin`,
      },
    });

    return next.handle(req);
  }
}
